import React from 'react';
import { Control, FieldErrors } from 'react-hook-form';
import { operacion } from '../../models/operacion';
import InputSelect from '../../../../components/inputs/yup/materialui/inputSelect';
import { Card, CardContent, Grid2, Typography } from '@mui/material';
import { selectorTransversal } from '../../../../dtos/selector';

interface OtroCreditoFormProps {
    control: Control<operacion>;
    finalidades: selectorTransversal[];
    utilidades: selectorTransversal[];
    listaOrigenes: selectorTransversal[];
    canalVentas: selectorTransversal[];
    isEditing: boolean;
    errors: FieldErrors<operacion>;
    isComplementario: boolean;
    isReadonlyWithPermission: () => boolean;
    esVigente?: boolean;
    permisoCarteraMutuoEditarInfo: boolean;
}

const OtroCreditoForm: React.FC<OtroCreditoFormProps> = ({ control, finalidades, utilidades, listaOrigenes, canalVentas, isEditing, errors, isComplementario, isReadonlyWithPermission, esVigente, permisoCarteraMutuoEditarInfo }) => {
    // Acá se omite la lógica de isReadonlyStandardCarteraMutuo,
    // porque en algunos campos del formulario los mutuos complementarios pueden editarlo.
    const isReandonlyParaComplementarios = () => {
        let result = !isEditing && (esVigente && !permisoCarteraMutuoEditarInfo);
        return result ?? true;
    }
    return (
        <Card sx={{ mb: 2, backgroundcolor: 'white' }} raised>
            <CardContent>
                <Typography className='card-title' variant="h6" gutterBottom>
                    Otros créditos
                </Typography>
                <Grid2 container spacing={2} mt={2}>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputSelect
                            label='Finalidad crédito'
                            name="finalidadCredito"
                            control={control}
                            options={finalidades}
                            disabled={isReadonlyWithPermission()}
                            error={errors.finalidadCredito}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputSelect
                            label="Utilidad"
                            name="utilidad"
                            control={control}
                            options={utilidades}
                            disabled={isReandonlyParaComplementarios()}
                            error={errors.utilidad}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputSelect
                            label="Origen"
                            name="origen"
                            control={control}
                            options={listaOrigenes}
                            disabled={isReandonlyParaComplementarios()}
                            error={errors.origen}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputSelect
                            label="Canal venta"
                            name="canalVenta"
                            control={control}
                            options={canalVentas}
                            disabled={isReandonlyParaComplementarios()}
                            error={errors.canalVenta}
                        />
                    </Grid2>
                </Grid2>
            </CardContent>
        </Card>
    );
};

export default OtroCreditoForm;
